import {defineStore} from "pinia";
import type {APIUser} from "~/types/user";

export const useUserStore = defineStore('userStore', () => {
    const user = ref<APIUser|undefined>(undefined)
    const isLoggedIn = computed(() => !!user.value)

    const bind = (u: APIUser) => {
        user.value = u
    }

    const logout = () => {
        user.value = undefined
    }

    return { user, isLoggedIn, bind, logout }
})